<ion-app>
  <app-toast></app-toast>
  <app-area-date-time-picker></app-area-date-time-picker>

  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
